
import BaseView from "@core/View.js";
import Alert from "@util/alert.js";
import {$util} from "@util/util.js";
export default class GiftView extends BaseView{
    constructor(model){
        super(model);
        this._model._view = this;
        // console.log('赠品的数据',this._model);
        this._parentEl = this._model._parent._view._extraBoxEl;
    }
    itemGoodInfo(item){
        let items = item._parent
        
        if(item._invalid || this._model._parent._invalid ){
            // return `<span class="le_tip_btn_solid ${!items._invalid ? '' : 'receive_good_without'}">已赠完</span>`
            return `<span class="le_tip_btn_solid ${!items._invalid ? '' : 'receive_good_without'}">已赠完</span>`

        }else if(this._model._parent._stock <=0){
            return `<span class="le_tip_btn_solid ${this._model._parent._stock <=0 ? '' : 'receive_good_without'}">已赠完</span>`
        }else if(!this._model._parent._marketable){
            return `<span class="le_tip_btn_solid ${this._model._parent._stock <=0 ? '' : 'receive_good_without'}">已赠完</span>`
        }else if(item._stock >= 1 && item._stock < this._model._parent._count){
            return `<span class="le_tip_btn_solid ${!items._invalid ? '' : 'receive_good_without'}">还有${item._stock}件</span>`
        }else {
            return ` `
        }
    }

    getItems(){
        let html = "";
        html += `<div class="fl extra_item_middle">`;
        this._model._items.forEach((item) => {
        // console.log('item',item);
            html += `
            <div class="clearfix right_item" ids=${item._id}>
                <div class="fl e_goods">
                <span class="fl e_goods_img" style="opacity:${(this._model._parent._invalid || item._invalid || !this._model._parent._marketable || this._model._parent._stock <= 0 ) ? '0.5':'1'}">
                    <a target="_blank" style="opacity:${(this._model._parent._invalid || item._invalid || !this._model._parent._marketable || this._model._parent._stock  <= 0) ? '0.5': '1'}" href="${item._link}"><img src="${item._img}"></a>
                </span>
                <span class="fl e_goods_desc">
                    <p style="opacity:${(this._model._parent._invalid || item._invalid || !this._model._parent._marketable || this._model._parent._stock <= 0 )? '0.5': '1'}"><a target="_blank"  class="${(item._invalid || this._model._parent._stock <= 0 ) ? 'disable':''}" href="${item._link}">${item._name}</a></p>
                    ${this.itemGoodInfo(item)}
                </span>
                </div>
                <div class="fl le_width_172 e_price" style="height:20px"></div>
                <div class="fl le_width_172 e_quantity" style="opacity:${(this._model._parent._invalid || item._invalid || !this._model._parent._marketable || this._model._parent._stock <= 0 ) ? '0.5' : '1'};height:20px;" style="position:relative;left:172px;"><span style="display:${(this._model._parent._invalid || item._invalid || !this._model._parent._marketable || this._model._parent._stock <= 0 ) ? 'none':'inline-block'}">${item._count}</span></div>
                <div class="fl le_width_172 e_sum" style="opacity:${item._invalid ? '0.5': '1'}"></div>
                <div style="position:relative;left:172px;display:${item._data.optionGiftFlag && !this._model._parent._invalid ?'inline-block':'none'};"><div class="e_action"><p class="le_paddingl_26" tag="re_receive">重选</p></div></div>
            </div>`
        });
        html += `</div>`
       
        return html;
    }
    render(){
        // console.log('赠品是否可重选',this._model);
        let tmpId = this._model.__tempId + "_" + this._model._parent._id + '_' +this._model._parent._itemId;
        let html = "";
        html += `
            <div class="clearfix extra_item giftbox ${this.getInvalidInfo().cls}" skuid='${tmpId}'>
                <div class="fl e_name extra_item_left ${this.getInvalidInfo().cls}">赠品</div>
                ${this.getItems()}`;
        $(this._parentEl).append($(html));
        this._el = $("div.giftbox[skuid='"+tmpId+"']");
        this.regEvent();
    }
    regEvent(){
        let that = this;
        let clicktag = 0;
        this._el.off("click","p[tag='re_receive']").on("click","p[tag='re_receive']",function(){
            if (clicktag == 0) {
                clicktag = 1
                setTimeout(function() {
                    clicktag = 0;
                  }, 500);
                that._model._parent.getGiftGoods().then((res)=>{
                    $('.receive_wrapper').show();
                    $('.pc_mask').show();
                    that._model._parent._giftList._view.render();
                    $util.toggleBodyScroller(true);
            
                }).catch(err => { 
                   $('.option_wrappers').show();
                   $('.pc_mask').show();
                   $util.toggleBodyScroller(true);
                   $(".option_wrappers h3").html(`<i class="fr close_receive iconfont icon-close" tag="onClickIconClose"></i>选择赠品`);
                   $(".optionsNone_text").html(`暂无赠品`);
                   //  Alert.showTip(err);
                });
            }
            
         
         })
         $('.option_wrappers').off("click","[tag='onClickIconClose']").on("click","[tag='onClickIconClose']",function(){
            $('.option_wrappers').hide();
            $('.pc_mask').hide();
            $util.toggleBodyScroller(false);
            
        })

    }
}